/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Audience_Heading3Inputs */

const zh_landing_audience_heading3 = /** @type {(inputs: Landing_Audience_Heading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`量身打造！`)
};

const en_landing_audience_heading3 = /** @type {(inputs: Landing_Audience_Heading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`out there!`)
};

const es_landing_audience_heading3 = /** @type {(inputs: Landing_Audience_Heading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡que existe!`)
};

/**
* | output |
* | --- |
* | "out there!" |
*
* @param {Landing_Audience_Heading3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_audience_heading3 = /** @type {((inputs?: Landing_Audience_Heading3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Audience_Heading3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_audience_heading3(inputs)
	if (locale === "en") return en_landing_audience_heading3(inputs)
	return es_landing_audience_heading3(inputs)
});